import styled, { css } from "styled-components";

import { hideScrollbarY } from "@styles/mixin";

import type { ShellColumnSize } from "@FillInTableContainer/shared/types/shellSize.types";

interface ListBoxWrapperProps {
  columnSize: ShellColumnSize;
  $isFixed?: boolean;
  $fixedTop?: number;
  $fixedLeft?: number;
  $fixedWidth?: number;
}

export const ListBoxWrapper = styled.div<ListBoxWrapperProps>`
  min-width: 8.8rem;
  max-height: 32rem;
  background-color: ${({ theme }) => theme.color.neural.white};
  border: 0.1rem solid ${({ theme }) => theme.color.neural.gray03};
  border-radius: 0 0 0.4rem 0.4rem;
  padding: 0rem 0rem 1.6rem;
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.08);

  ${({ $isFixed, $fixedTop, $fixedLeft, $fixedWidth }) =>
    $isFixed
      ? css`
          position: fixed;
          top: ${$fixedTop ?? 0}px;
          left: ${$fixedLeft ?? 0}px;
          width: ${$fixedWidth ?? 0}px;
          z-index: 30;
        `
      : css`
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: calc(100% + 0.1rem);
          width: calc(100% + 0.2rem);
          z-index: 12;
        `}
`;

export const ListScrollWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 28rem;

  ${hideScrollbarY};
`;
